export default {
	attributes: {
		design: 'basic',
		columns: 2,
		columnBackgroundCustomSizeUnit: '%',
		columnTabletBackgroundCustomSizeUnit: '%',
		columnMobileBackgroundCustomSizeUnit: '%',
		showImage: true,
		imageShape: 'circle',
		imageSize: 'thumbnail',
		image1Id: 597,
		image2Id: 596,
		image1Url: 'https://source.unsplash.com/400x300/?donut',
		image2Url: 'https://source.unsplash.com/400x300/?coffee',
		image1Alt: 'Title',
		image2Alt: 'Title',
		image1ShapeFlipX: false,
		image1ShapeFlipY: false,
		image1ShapeStretch: false,
		image2ShapeFlipX: false,
		image2ShapeFlipY: false,
		image2ShapeStretch: false,
		image3ShapeFlipX: false,
		image3ShapeFlipY: false,
		image3ShapeStretch: false,
		image4ShapeFlipX: false,
		image4ShapeFlipY: false,
		image4ShapeStretch: false,
		showTitle: true,
		title1: 'Title',
		title2: 'Title',
		titleLineHeightUnit: 'em',
		titleTabletLineHeightUnit: 'em',
		titleMobileLineHeightUnit: 'em',
		showDescription: true,
		description1: 'Description for this block. Place your content in here.',
		description2: 'Description for this block. Place your content in here.',
		descriptionLineHeightUnit: 'em',
		descriptionTabletLineHeightUnit: 'em',
		descriptionMobileLineHeightUnit: 'em',
		showButton: true,
		buttonFontSize: 18,
		buttonLineHeightUnit: 'em',
		buttonTabletLineHeightUnit: 'em',
		buttonMobileLineHeightUnit: 'em',
		button1LineHeightUnit: 'em',
		button1TabletLineHeightUnit: 'em',
		button1MobileLineHeightUnit: 'em',
		button1Text: 'Button text',
		button1NewTab: false,
		button2LineHeightUnit: 'em',
		button2TabletLineHeightUnit: 'em',
		button2MobileLineHeightUnit: 'em',
		button2Text: 'Button text',
		button2NewTab: false,
		button3LineHeightUnit: 'em',
		button3TabletLineHeightUnit: 'em',
		button3MobileLineHeightUnit: 'em',
		button3NewTab: false,
		button4LineHeightUnit: 'em',
		button4TabletLineHeightUnit: 'em',
		button4MobileLineHeightUnit: 'em',
		button4NewTab: false,
		uniqueClass: 'ugb-f90ca74',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
		showBlockBackground: false,
		blockBackgroundBackgroundCustomSizeUnit: '%',
		blockBackgroundTabletBackgroundCustomSizeUnit: '%',
		blockBackgroundMobileBackgroundCustomSizeUnit: '%',
		topSeparatorDesign: 'wave-1',
		bottomSeparatorDesign: 'wave-1',
		topSeparatorShadow: true,
		bottomSeparatorShadow: true,
		showBlockTitle: false,
		blockTitleLineHeightUnit: 'em',
		blockTitleTabletLineHeightUnit: 'em',
		blockTitleMobileLineHeightUnit: 'em',
		showBlockDescription: false,
		blockDescriptionLineHeightUnit: 'em',
		blockDescriptionTabletLineHeightUnit: 'em',
		blockDescriptionMobileLineHeightUnit: 'em',
	},
}
